<template>
  <v-tabs :value="value" background-color="transparent" grow @change="handleInput">
    <v-tabs-slider/>
    <v-tab
        v-for="label in labels"
        :key="`tab-${label}`"
    >
      {{ label }}
    </v-tab>
  </v-tabs>
</template>

<script>
export default {
  name: "Tabs",
  props: {
    value: {
      type: Number
    },
    labels: {
      type: Array
    }
  },
  methods: {
    handleInput(value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style scoped>

</style>